import {
  svgFromString
} from './utilities';

export const spinner = svgFromString(`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="12" viewBox="0 0 32 12" role="img" aria-label="Typing" fill="none" style="
  color: var(--startup-primary-color);
">
  <style>
    .dot {
      fill: currentColor;
      opacity: 0.24;
      transform-box: fill-box;
      transform-origin: center;
      will-change: transform, opacity;
      animation-duration: 5s;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
    }
    .d1 { animation-name: wave1; }
    .d2 { animation-name: wave2; }
    .d3 { animation-name: wave3; }

    @keyframes wave1 {
      0%, 4%  { transform: translateY(0px);     opacity: 0.24; }
      8%      { transform: translateY(-1.05px); opacity: 0.42; }
      12%     { transform: translateY(-1.8px);  opacity: 0.62; }
      16%     { transform: translateY(-1.05px); opacity: 0.42; }
      20%     { transform: translateY(0px);     opacity: 0.24; }
      24%     { transform: translateY(1.05px);  opacity: 0.18; }
      28%     { transform: translateY(1.8px);   opacity: 0.16; }
      32%     { transform: translateY(1.05px);  opacity: 0.18; }
      36%     { transform: translateY(0px);     opacity: 0.24; }
      40%     { transform: translateY(-1.05px); opacity: 0.42; }
      44%     { transform: translateY(-1.8px);  opacity: 0.62; }
      48%     { transform: translateY(-1.05px); opacity: 0.42; }
      52%     { transform: translateY(0px);     opacity: 0.24; }
      56%     { transform: translateY(1.05px);  opacity: 0.18; }
      60%     { transform: translateY(1.8px);   opacity: 0.16; }
      64%     { transform: translateY(1.05px);  opacity: 0.18; }
      68%     { transform: translateY(0px);     opacity: 0.24; }
      72%     { transform: translateY(-1.05px); opacity: 0.42; }
      76%     { transform: translateY(-1.8px);  opacity: 0.62; }
      80%     { transform: translateY(-1.05px); opacity: 0.42; }
      84%     { transform: translateY(0px);     opacity: 0.24; }
      86%     { transform: translateY(-1.05px); opacity: 0.42; }
      88%     { transform: translateY(-1.8px);  opacity: 0.62; }
      90%     { transform: translateY(-1.05px); opacity: 0.42; }
      92%     { transform: translateY(0px);     opacity: 0.24; }
      100%    { transform: translateY(0px);     opacity: 0.24; }
    }

    @keyframes wave2 {
      0%, 8%  { transform: translateY(0px);     opacity: 0.24; }
      12%     { transform: translateY(-1.05px); opacity: 0.42; }
      16%     { transform: translateY(-1.8px);  opacity: 0.62; }
      20%     { transform: translateY(-1.05px); opacity: 0.42; }
      24%     { transform: translateY(0px);     opacity: 0.24; }
      28%     { transform: translateY(1.05px);  opacity: 0.18; }
      32%     { transform: translateY(1.8px);   opacity: 0.16; }
      36%     { transform: translateY(1.05px);  opacity: 0.18; }
      40%     { transform: translateY(0px);     opacity: 0.24; }
      44%     { transform: translateY(-1.05px); opacity: 0.42; }
      48%     { transform: translateY(-1.8px);  opacity: 0.62; }
      52%     { transform: translateY(-1.05px); opacity: 0.42; }
      56%     { transform: translateY(0px);     opacity: 0.24; }
      60%     { transform: translateY(1.05px);  opacity: 0.18; }
      64%     { transform: translateY(1.8px);   opacity: 0.16; }
      68%     { transform: translateY(1.05px);  opacity: 0.18; }
      72%     { transform: translateY(0px);     opacity: 0.24; }
      76%     { transform: translateY(-1.05px); opacity: 0.42; }
      80%     { transform: translateY(-1.8px);  opacity: 0.62; }
      82%     { transform: translateY(-1.05px); opacity: 0.42; }
      84%     { transform: translateY(0px);     opacity: 0.24; }
      86%     { transform: translateY(-1.05px); opacity: 0.42; }
      88%     { transform: translateY(-1.8px);  opacity: 0.62; }
      90%     { transform: translateY(-1.05px); opacity: 0.42; }
      92%     { transform: translateY(0px);     opacity: 0.24; }
      100%    { transform: translateY(0px);     opacity: 0.24; }
    }

    @keyframes wave3 {
      0%, 12% { transform: translateY(0px);     opacity: 0.24; }
      16%     { transform: translateY(-1.05px); opacity: 0.42; }
      20%     { transform: translateY(-1.8px);  opacity: 0.62; }
      24%     { transform: translateY(-1.05px); opacity: 0.42; }
      28%     { transform: translateY(0px);     opacity: 0.24; }
      32%     { transform: translateY(1.05px);  opacity: 0.18; }
      36%     { transform: translateY(1.8px);   opacity: 0.16; }
      40%     { transform: translateY(1.05px);  opacity: 0.18; }
      44%     { transform: translateY(0px);     opacity: 0.24; }
      48%     { transform: translateY(-1.05px); opacity: 0.42; }
      52%     { transform: translateY(-1.8px);  opacity: 0.62; }
      56%     { transform: translateY(-1.05px); opacity: 0.42; }
      60%     { transform: translateY(0px);     opacity: 0.24; }
      64%     { transform: translateY(1.05px);  opacity: 0.18; }
      68%     { transform: translateY(1.8px);   opacity: 0.16; }
      72%     { transform: translateY(1.05px);  opacity: 0.18; }
      76%     { transform: translateY(0px);     opacity: 0.24; }
      78%     { transform: translateY(-1.05px); opacity: 0.42; }
      80%     { transform: translateY(-1.8px);  opacity: 0.62; }
      82%     { transform: translateY(-1.05px); opacity: 0.42; }
      84%     { transform: translateY(0px);     opacity: 0.24; }
      100%    { transform: translateY(0px);     opacity: 0.24; }
    }
  </style>

	<circle class="dot d1" cx="6" cy="6" r="2"></circle>
  <circle class="dot d2" cx="16" cy="6" r="2"></circle>
  <circle class="dot d3" cx="26" cy="6" r="2"></circle>
</svg>`);